import { EventShim, EventTagerShim } from "../EventTaget/index";
import { deepFindLog, now, noop } from "../utils/index";
import eventCatch from "../eventCatch/index";
const logAttributeMap = {
  "data-log-view": "data-log-view",
  "data-log-click": "data-log-click",
  "data-log-extra": "data-log-extra",
  "data-log-render": "data-log-render",
  "data-log-outview": "data-log-outview",
  "data-log-view-stay": "data-log-view-stay"
};
export class LogEvent {
  constructor(target, logPath, info) {
    this.type = info.type;
    Object.assign(this, info);
    this.log = Object.assign({}, ...[...logPath].reverse());
    this.path = logPath;
    this.target = target;
    this.time = now();
  }

}

class WilClickEventEvent extends EventShim {
  constructor(type, event) {
    super(type);
    this.from = event;
  }

}

class WilLogEvent extends EventShim {
  constructor(type, event) {
    super(type);
    this.from = event;
  }

}

class WilClickEventTaget extends EventTagerShim {
  constructor(fn, option = {}) {
    super();
    this.config = Object.assign({}, logAttributeMap, option.attribute);
    this.init(fn);
  }

  init(fn) {
    eventCatch(event => {
      this.dispatchEvent(new WilClickEventEvent("clickEvent", event));
    });
    this.addEventListener("clickEvent", event => {
      this.handleClickEvent(event);
    });
    this.listenLogEvent(fn);
    this.fixIOSSafari();
  }

  fixIOSSafari() {
    if (document.body) {
      for (let i = 0, nodes = document.body.childNodes; i < nodes.length; i++) {
        const node = nodes[i];

        if (node instanceof Element && node.nodeType === 1) {
          node["onclick"] = noop;
        }
      }
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        for (let i = 0, nodes = document.body.childNodes; i < nodes.length; i++) {
          const node = nodes[i];

          if (node instanceof Element && node.nodeType === 1) {
            node["onclick"] = noop;
          }
        }
      });
    }
  }

  handleClickEvent(e) {
    const event = e.from;
    this.handleMouseEvent(event);
  }

  handleMouseEvent(e) {
    const targetElement = e.target;

    if (targetElement && (targetElement instanceof HTMLElement || targetElement instanceof SVGElement) && targetElement.nodeType === 1 && e.type == "click") {
      const attributeName = this.config["data-log-click"];
      const attributeExtraName = this.config["data-log-extra"];
      const log = deepFindLog(targetElement, attributeName, attributeExtraName);

      if (log !== null) {
        this.dispatchEvent(new WilLogEvent("logEvent", new LogEvent(targetElement, log, {
          type: "click"
        })));
      }
    }
  }

  listenLogEvent(fn) {
    this.addEventListener("logEvent", e => {
      const event = e.from;
      fn(event);
    });
  }

}

export default WilClickEventTaget;